import moment from 'moment';
import { EMARPOLDocuments, TMARPOLTank } from '../../marpol/@types';
import {
    ECRBRecordCode,
    ECRBRecordState,
    TCRBCommonData,
    TCRBCommonFields,
} from '../@types';
import { TCRBPlace } from '../@types';

export type TCRBItem7 = {
    placeOfBallast: TCRBPlace;
};

export type TCRBItem8 = {
    tanks: TCRBItem8Tank[];
};

export type TCRBItem8Tank = {
    selectedTank: TMARPOLTank;
    transferQuantity: number;
    newQuantity: number;
};

export type TCRBitem8P1 = {
    startDate: string;
    startTime: string;
    endDate: string;
    endTime: string;
};

export type TCRBItem9 = {
    wereTanksEmptied: boolean;
    content: string;
};

export type TCRBItem10 = {
    prewashRequired: boolean;
};

export type TCRBItem11 = {
    failure: boolean;
    failureDate: string;
    failureTime: string;
    natureOfFailure: string;
    reasonOfFailure: string;
    operationalDate: string;
    operationalTime: string;
};

export type TCRBC1 = TCRBCommonFields &
    TCRBCommonData & {
        id: string;
        recordCode: ECRBRecordCode.CRBC;
        item7: TCRBItem7;
        item8: TCRBItem8;
        item8P1: TCRBitem8P1;
        item9: TCRBItem9;
        item10: TCRBItem10;
        item11: TCRBItem11;
    };

export type TCRBC = TCRBC1;

const CRBC_DEFAULTS: {
    C: TCRBC1;
} = {
    C: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.CRB,
        state: ECRBRecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item7: {
            placeOfBallast: {
                place: 'IN_PORT',
                portName: '',
            },
        },
        item8: {
            tanks: [],
        },
        item8P1: {
            startDate: '',
            startTime: '',
            endDate: '',
            endTime: '',
        },
        item9: {
            wereTanksEmptied: false,
            content: '',
        },
        item10: {
            prewashRequired: false,
        },
        item11: {
            failure: false,
            failureDate: '',
            failureTime: '',
            natureOfFailure: '',
            reasonOfFailure: '',
            operationalDate: '',
            operationalTime: '',
        },
        recordCode: ECRBRecordCode.CRBC,
    },
};

export { CRBC_DEFAULTS };
